import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { usersDataListRequest, usersDataListRequestError, usersDataListRequestSuccess } from "../../slices/Dashboard/userDataSlice";


export const GetUsersDataAPI = () => async (dispatch) => {
    try {
        dispatch(usersDataListRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getUsersData,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(usersDataListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(usersDataListRequestError(_error));
            });
    } catch (error) { }
};
